"use client";

import React from "react";
import Image from "next/image";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { Facebook, Instagram } from "lucide-react";
// import { FaXTik } from "react-icons/fa6";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { useUserStore } from "@/store/store";

export default function Footer() {
  const t = useTranslations();
  const { role } = useUserStore();
  const pricingHref = `/${role}/pricing`;

  return (
    <footer className="flex flex-col items-center gap-8 text-white pt-6 md:pt-12 pb-2 bg-black">
      <div className="mb-6">
        <Image
          src="/logo.webp"
          alt="logo"
          width={1000}
          height={1000}
          className="w-20 md:w-24 lg:w-28 object-contain mx-auto"
        />
      </div>

      <nav className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm md:text-base font-poppins mb-6">
        <Link href="/" className="hover:underline">
          {t("general.home")}
        </Link>
        <Link href={pricingHref} className="hover:underline">
          {t("general.pricing")}
        </Link>
        <Link href="/contact-us" className="hover:underline">
          {t("general.contact_us")}
        </Link>
        <Link href="/privacy-policy" className="hover:underline">
          {t("general.privacy_policy")}
        </Link>
        <Link href="/terms-and-conditions" className="hover:underline">
          {t("general.terms_and_conditions")}
        </Link>
      </nav>

      <div className="flex justify-center gap-4 md:gap-6 mb-6">
        <a
          href="https://www.facebook.com/gritizer.inc"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Facebook className="w-6 h-6 hover:text-primary fill-secondary hover:fill-primary hover:scale-110" />
        </a>
        {/* <a
          href="https://twitter.com"
          aria-label="Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaXTwitter className="w-6 h-6 hover:text-primary fill-secondary hover:fill-primary hover:scale-110" />
        </a> */}
        <a
          href="https://www.instagram.com/gritizer.inc/"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram className="w-6 h-6 hover:text-primary hover:scale-110" />
        </a>
        <a
          href="https://www.tiktok.com/@gritizer.inc"
          aria-label="tiktok"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faTiktok} className="w-6 h-6 text-lg font-bold hover:text-primary hover:scale-110"/>
        </a>
      </div>

      <p className="text-center text-xs md:text-sm font-poppins">
        {t("general.copy_right")} {new Date().getFullYear()} {t("general.copy_right2")}
      </p>
    </footer>
  );
}
